export default __webpack_public_path__ + "static/media/usuario.a22caf4b.svg";